export default __webpack_public_path__ + "static/media/fabrics.00d7ebf0.jpg";